<template>
  <v-toolbar
    id="appToolbar"
    color="primary"
    fixed
    dark
    app
    >
    <v-toolbar-title class="ml-0 pl-3">
      <v-toolbar-side-icon @click.stop="handleDrawerToggle"></v-toolbar-side-icon>
    </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-menu v-if="role==='staf.agroforestcape@gmail.com' && !pesananPengiriman" offset-y :nudge-bottom="10" :nudge-left="315" transition="scale-transition">
        <v-btn icon flat slot="activator">
          <v-badge v-if="kontrak" color="red" overlap>
            <span slot="badge">1</span>
            <v-icon medium>notifications</v-icon>
          </v-badge>
          <v-badge v-else overlap>
            <v-icon medium>notifications</v-icon>
          </v-badge>
        </v-btn>
        <notification-list-perusahaan></notification-list-perusahaan>
      </v-menu>

      <v-menu v-else-if="role==='staf.agroforestcape@gmail.com' && pesananPengiriman" offset-y :nudge-bottom="10" :nudge-left="315" transition="scale-transition">
        <v-btn icon flat slot="activator">
          <v-badge color="red" overlap>
            <span slot="badge">1</span>
            <v-icon medium>notifications</v-icon>
          </v-badge>
        </v-btn>
        <notification-list-gapoktan></notification-list-gapoktan>
      </v-menu>

      <v-menu v-else-if="role==='gapoktan.agroforestcape@gmail.com'" offset-y :nudge-bottom="10" :nudge-left="315" transition="scale-transition">
        <v-btn icon flat slot="activator">
          <v-badge color="red" overlap>
            <span slot="badge">1</span>
            <v-icon medium>notifications</v-icon>
          </v-badge>
        </v-btn>
        <notification-list-gapoktan></notification-list-gapoktan>
      </v-menu>

      <v-menu v-else-if="role==='logistik.agroforestcape@gmail.com'" offset-y :nudge-bottom="10" :nudge-left="315" transition="scale-transition">
        <v-btn icon flat slot="activator">
          <v-badge color="red" overlap>
            <span slot="badge">1</span>
            <v-icon medium>notifications</v-icon>
          </v-badge>
        </v-btn>
        <notification-list-logistik></notification-list-logistik>
      </v-menu>

      <v-menu v-else-if="role==='gov.agroforestcape@gmail.com'" offset-y :nudge-bottom="10" :nudge-left="315" transition="scale-transition">
        <v-btn icon flat slot="activator">
          <v-badge>
            <v-icon medium>notifications</v-icon>
          </v-badge>
        </v-btn>
      </v-menu>

      <v-menu v-else-if="role==='company.agroforestcape@gmail.com'" offset-y :nudge-bottom="10" :nudge-left="315" transition="scale-transition">
        <v-btn icon flat slot="activator">
          <v-badge>
            <v-icon medium>notifications</v-icon>
          </v-badge>
        </v-btn>
      </v-menu>

      <v-menu v-else offset-y :nudge-bottom="10" :nudge-left="315" transition="scale-transition">
        <v-btn icon flat slot="activator">
          <v-badge>
            <v-icon medium>notifications</v-icon>
          </v-badge>
        </v-btn>
      </v-menu>

      <!-- <v-btn icon @click="handleFullScreen()">
        <v-icon>fullscreen</v-icon>
      </v-btn> -->

      <!-- <v-spacer></v-spacer> -->

      <!-- Profile Start -->

      <v-menu offset-y origin="center center" :nudge-bottom="10" transition="scale-transition">
        <v-btn icon large flat slot="activator">
          <v-avatar size="30px">
            <img src="/static/avatar/man_4.jpg" alt="Michael Wang"/>
          </v-avatar>
        </v-btn>

        <v-list class="pa-0">
          <v-list-tile 
            v-for="(item,index) in items" 
            :to="!item.href ? { name: item.name } : null" 
            :href="item.href" @click="item.click" ripple="ripple" 
            :disabled="item.disabled" 
            :target="item.target" rel="noopener" 
            :key="index
          ">
            <v-list-tile-action v-if="item.icon">
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-menu>

      <!-- Profile End -->

  </v-toolbar>
</template>

<script>
import NotificationListPerusahaan from '@/components/perusahaan/NotificationListPerusahaan';
import NotificationListGapoktan from '@/components/gapoktan/NotificationListGapoktan';
import NotificationListLogistik from '@/components/logistik/NotificationListLogistik';
import Util from '@/util';

export default {
  name: 'app-toolbar',
  components: {
    NotificationListPerusahaan,
    NotificationListGapoktan,
    NotificationListLogistik
  },
  data: () => ({
    items: [
      // {
      //   icon: 'account_circle',
      //   href: '#',
      //   title: 'Profile',
      //   click: (e) => {
      //     window.getApp.$emit('APP_ADMIN_PROFILE');
      //   }
      // },
      {
        icon: 'logout',
        href: '#',
        title: 'Logout',
        click: (e) => {
          window.getApp.$emit('APP_LOGOUT');
        }
      }
    ],
    role: localStorage.userEmail,
  }),
  computed: {
    toolbarColor () {
      return this.$vuetify.options.extra.mainNav;
    },
    kontrak(){
      return localStorage.kontrakID;
    },
    pesananPengiriman(){
      return localStorage.komoditasPesananPengirimanID;
    }
  },
  methods: {
    handleDrawerToggle () {
      window.getApp.$emit('APP_DRAWER_TOGGLED');
    },
    handleFullScreen () {
      Util.toggleFullScreen();
    }
  }
};
</script>

<style>

  @media all{
    #appToolbar{
      display: block;
    }
  }

  @media print{
    #appToolbar{
      display: none;
    }
  }
</style>
